import { healthDayKey } from './healthTime';

const occs = (row) => (Array.isArray(row?.occurrences) && row.occurrences.length
  ? row.occurrences
  : [{ started_at: row?.started_at, outcome: null }]);

/** Occurrences (flattened, with their row) that started on `now`'s day in tz. */
export function todayOccurrences(timeline, tz, now = Date.now()) {
  const today = healthDayKey(now, tz);
  const out = [];
  (timeline || []).forEach((row) => occs(row).forEach((o) => {
    if (healthDayKey(o.started_at, tz) === today) out.push({ row, o });
  }));
  return out;
}

/** {incidents, markers} started today — the numbers the timeline header shows. */
export function timelineTotals(timeline, tz, now) {
  const list = todayOccurrences(timeline, tz, now);
  return {
    incidents: list.filter((x) => x.row.kind === 'incident').length,
    markers: list.filter((x) => x.row.kind === 'marker').length,
  };
}

/** Mirror of the backend counters rule, derived from the timeline itself. */
export function countersFromTimeline(timeline, tz, now) {
  const c = { disconnects: 0, rtdb_stalls: 0, audio_repairs: 0, audio_repairs_failed: 0, picture_recoveries: 0, app_restarts: 0, crashes: 0, app_updates: 0 };
  todayOccurrences(timeline, tz, now).forEach(({ row, o }) => {
    const k = row.template_key;
    if (row.kind === 'marker') { if (k === 'app_lifecycle.cold_start') c.app_restarts++; else if (k === 'app.updated') c.app_updates++; return; }
    if (k === 'network.disconnected') c.disconnects++;
    else if (k === 'network.rtdb_stall' || k === 'network.rtdb_stall_critical' || k === 'network.rtdb_socket_closed') c.rtdb_stalls++;
    else if (row.category === 'AUDIO') {
      if (o.outcome === 'repaired') c.audio_repairs++;
      else if (o.outcome === 'gave_up') c.audio_repairs_failed++;
    } else if (k === 'video.renderer_gone') c.picture_recoveries++;
    else if ((k === 'playback.stalled' || k === 'playback.gave_up' || k === 'playback.outage_started') && o.outcome === 'recovered'
      && !['intentional_stop', 'mode_changed'].includes((o.steps ?? [])[(o.steps ?? []).length - 1]?.params?.reason)) c.picture_recoveries++;
    else if (k === 'app_lifecycle.crash') c.crashes++;
  });
  return c;
}
